'use strict';

function LoanOverview() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];
  this.loanStateRoutingEnabled = true;

  this._moneyModelPath = 'money.loans';

  // View path is the path to the pug view not URL
  this.overviewStates = {
    active: {
      viewPath: '/member/loans/product/dashboard',
      viewId: 'LoanDetails'
    },
    paid_off: {
      viewPath: '/member/loans/dashboard/tabs/overview/paid-off',
      viewId: 'LoanOverviewPaidOff'
    },
    closed: {
      viewPath: '/member/loans/dashboard/tabs/overview/closed'
    },
    pending: {
      viewPath: '/member/loans/dashboard/tabs/overview/pending'
    }
  };

  this.init = function () {
    this._super();

    this._portalPresenter = document.getElementById('Portal').mogo();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    this._pushAnalytics();
    this._loanStatus = this._getLoanStatus();
    this._applicationStatus = this._getApplicationStatus();
    this._applicationStatus = this._applicationStatus && this._applicationStatus.status ? this._applicationStatus.status : null;
    if (!this._loanStatus) return;

    this._$node = $(this.node);
    this._setupViewSection(this._loanStatus.status, this._applicationStatus, this.overviewStates);
  };

  this.destroy = function () {
    this._super();
  };

  this._setupViewSection = function (loanStatus, applicationStatus, stateObj) {
    var viewPath = void 0;
    var viewId = void 0;

    if (applicationStatus === 'agreements_ready' || applicationStatus === 'agreements_signed' || applicationStatus === 'agreements_expired' && loanStatus === 'paid_off') {
      loanStatus = 'pending';
    }

    var view = stateObj[loanStatus];

    if (view) {
      viewPath = view.viewPath;

      if (view.viewId) viewId = view.viewId;
    }

    // Inject View via ajax
    this._viewLoad(viewPath, viewId);
  };

  this._viewLoad = function (viewPath, viewId) {
    if (viewPath) {
      $.ajax({
        url: viewPath,
        type: 'GET',
        headers: {
          'Content-Type': 'text/html'
        },
        dataType: 'html',
        success: this._onViewLoadSuccess.bind(this, viewId)
      });
    } else {
      console.error('LoanOverview: No view path or status');
    }
  };

  this._onViewLoadSuccess = function (viewId, data) {
    // Insert into document
    this._$node.append(data);

    mogo.ready(function (vId) {
      var element = $('#' + vId);

      if (element.length > 0) {
        // IMPORTANT: ust have .js--create-section to create mogo-component first since
        // we are dynamically injecting html in to the page.
        // use Parse to first to create mogo-components
        try {
          element.find('.js--create-section').mogo().parse();
        } catch (err) {
          console.warn(err);
        }

        // Init the page component
        element.mogo().create(vId, {
          presenter: this.presenter,
          analytics: this.analytics
        }, 'page');

        // Init Data-History
        // 1. Initialize analytics
        $('#Portal').mogo().scanNodeForClickAnalytics(element);
        // 2. Initialize history
        this.history.initializeHistoryOnDocument(element);

        this.presenter.scanDOM(element[0]);
      }

      // Required when route has defer_page_load_completed: true
      this._portalPresenter.setPageLoadComplete();
    }.bind(this, viewId));
  };

  this._pushAnalytics = function () {
    this.analytics.forcePushEvent('virtual-page-view');
    this.analytics.forcePushEvent('mogo-money-status', null, this);
  };
}